import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {ExpenseVouchers} from './expense_vouchers';

@Injectable()
export class ExpenseVouchersService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('expense_vouchers?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('expense_vouchers/logo').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('expense_vouchers/' + _id).map((response: Response) => response.json());
    }


    getTrashedById(_id: string) {
        return this.http.get('expense_vouchers/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('expense_vouchers/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(invoice: ExpenseVouchers) {
        return this.http.post('expense_vouchers', invoice).map((response: Response) => response.json());
    }

    update(invoice: ExpenseVouchers) {
        return this.http.put('expense_vouchers/' + invoice.id, invoice).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('expense_vouchers/' + _id).map((response: Response) => response.json());;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/expense_vouchers/expense_vouchers.service.ts